module.exports = __webpack_public_path__ + "img/31.b56f66c4.png";